function Footer() {
  return (
    <footer className="app-footer">
      <small>
        &copy; {new Date().getFullYear()} made by MITRA SISTEM SOLUSI
      </small>
    </footer>
  );
}

export default Footer;
